module.exports = __webpack_public_path__ + "gb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gb.svg
// module id = 556
// module chunks = 0